'use client';

import { ViewToggleGroup } from '@terra/ui-design-system';
import { GitBranchIcon, LeftToRightListBulletIcon } from '@terra/ui-icons';
import { useTranslations } from 'next-intl';

export type AssetRouteView = 'graph' | 'table';

const ROUTE_VIEW_VALUES = ['graph', 'table'] as const;

function isAssetRouteView(value: string): value is AssetRouteView {
  return value === 'graph' || value === 'table';
}

export function AssetRouteViewToggle({
  view,
  onViewChange,
}: {
  view: AssetRouteView;
  onViewChange: (view: AssetRouteView) => void;
}) {
  const tGraph = useTranslations('externalNetwork.assetDrawer');
  const tAssets = useTranslations('aiApplications.assets');

  return (
    <ViewToggleGroup
      value={view}
      onValueChange={(next) => {
        if (isAssetRouteView(next)) {
          onViewChange(next);
        }
      }}
      options={ROUTE_VIEW_VALUES.map((routeView) => ({
        value: routeView,
        icon: routeView === 'graph' ? GitBranchIcon : LeftToRightListBulletIcon,
        ariaLabel:
          routeView === 'graph' ? tGraph('assetGraph') : tAssets('listView'),
      }))}
    />
  );
}
